import { render, staticRenderFns } from "./Greetings.vue?vue&type=template&id=240f323e&scoped=true&"
import script from "./Greetings.vue?vue&type=script&lang=js&"
export * from "./Greetings.vue?vue&type=script&lang=js&"
import style0 from "./Greetings.vue?vue&type=style&index=0&id=240f323e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f323e",
  null
  
)

export default component.exports